import { WelcomeBonusRedesign } from '../redesign-components/WelcomeBonusRedesign/WelcomeBonusRedesign';

/** The redesigned welcome bonus opened on its own in the portal, outside of a wizard. */
export function WelcomeBonusRedesignPortal() {
  return <WelcomeBonusRedesign componentType="portal" />;
}
